import React from "react";

import { DialogModal } from "@churchofjesuschrist/eden-dialog-modal";
import { PlatformModal } from "@churchofjesuschrist/eden-platform-modal";
import styled from "styled-components";

const StyledModal = styled(DialogModal)`
> div{
  > div {
    >div{
  padding: 0 !important;
  padding-block-end:0 !important;
  }
  }
}
  overflow-y:auto !important;
  ${(props) => (props.width ? `min-width: ${props.width} !important;` : "")}
`;
const StyledPlatform = styled(PlatformModal)`
  ${(props) => (props.width ? `min-width: ${props.width} !important;` : "")}
`

const HeaderlessModal = ({ children, hideClose = false, ...props }) => {

  const UseModal = hideClose ? StyledPlatform : StyledModal;
  //modal now has active changed to open and onCloseGesture changed to onClose
  //this bit of code helps us migrate. I changed some, but didn't account for styled versions
  //which would put a whole ton more files to change. So we'll do this migration
  const migrateProps = {...props};
  if ((props.active === true || props.active === false ) && props.open === undefined)
  {
    migrateProps.open = props.active;
    migrateProps.active = undefined;
  }
  if (typeof props.onCloseGesture === "function" && typeof props.onClose !== "function") {
    migrateProps.onClose = props.onCloseGesture;
    migrateProps.onCloseGesture = undefined;
  }
  migrateProps.header = "";//as this is a headerless modal, we don't want the header text showing
  return <UseModal {...migrateProps} hideClose={hideClose}>{children}</UseModal>;
};

export default HeaderlessModal;
